import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full text-left" }
const _hoisted_2 = {
  key: 0,
  class: "text-textPrimary mb-2"
}
const _hoisted_3 = { class: "inline-flex flex-wrap items-center gap-2 p-1.5 rounded-lg bg-gray-200" }
const _hoisted_4 = ["data-testid", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "text-red-500 text-xs mt-1"
}

import { ref, PropType, watch } from 'vue'

interface SelectorOption {
  value: string | number
  label: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionSelect',
  props: {
  label: {
    type: String,
    default: ''
  },
  options: {
    type: Array as PropType<SelectorOption[]>,
    required: true
  },
  modelValue: {
    type: [String, Number, Array] as PropType<string | number | (string | number)[]>,
    required: true
  },
  multiple: {
    type: Boolean,
    default: false
  },
  errorMessages: {
    type: String,
    default: ''
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;





const localSelection = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newValue) => {
    localSelection.value = newValue
  }
)

const isSelected = (value: string | number) => {
  if (props.multiple && Array.isArray(localSelection.value)) {
    return localSelection.value.includes(value)
  }
  return localSelection.value === value
}

const toggleSelection = (value: string | number) => {
  if (props.multiple) {
    const selection = new Set(Array.isArray(localSelection.value) ? localSelection.value : [])
    if (selection.has(value)) {
      selection.delete(value)
    } else {
      selection.add(value)
    }
    localSelection.value = Array.from(selection)
  } else {
    localSelection.value = value
  }
  emit('update:modelValue', localSelection.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: option.value,
          "data-testid": `option-select-${option.value}`,
          onClick: ($event: any) => (toggleSelection(option.value)),
          class: _normalizeClass(["px-4 py-1.5 rounded-md text-sm font-medium transition-colors duration-200 focus:outline-none", 
          isSelected(option.value)
            ? 'bg-white text-gray-600 shadow-sm'
            : 'text-gray-600 hover:bg-gray-200'
        ])
        }, _toDisplayString(option.label), 11, _hoisted_4))
      }), 128))
    ]),
    (__props.errorMessages)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.errorMessages), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})